import { render, staticRenderFns } from "./CarPopular.vue?vue&type=template&id=245bb412"
import script from "./CarPopular.vue?vue&type=script&lang=js"
export * from "./CarPopular.vue?vue&type=script&lang=js"
import style0 from "./CarPopular.vue?vue&type=style&index=0&id=245bb412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports